import React from 'react';

const SvgInstagram = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" {...props}>
    <path d="M12.933 1.008h-7.95a3.987 3.987 0 00-3.975 3.975v7.95a3.987 3.987 0 003.975 3.975h7.95a3.987 3.987 0 003.975-3.975v-7.95a3.987 3.987 0 00-3.975-3.975zM8.958 12.27a3.313 3.313 0 110-6.626 3.313 3.313 0 010 6.626zm4.307-6.626a.994.994 0 11-.001-1.987.994.994 0 010 1.987z" />
  </svg>
);

export default SvgInstagram;
